import { render, staticRenderFns } from "./PracticalExamUpdate.vue?vue&type=template&id=35abdb88&"
import script from "./PracticalExamUpdate.vue?vue&type=script&lang=ts&"
export * from "./PracticalExamUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports